import React, { useContext, useEffect, useState } from 'react';
import { Box, TextField, Button, Typography, CircularProgress, Alert, IconButton, InputAdornment, useMediaQuery } from '@mui/material';
import { login } from '../services/AuthService';
import { Visibility, VisibilityOff } from '@mui/icons-material';

import { AuthContext } from "../utils/AuthContext";
import { Link, useNavigate, useSearchParams } from 'react-router-dom';

import { ToastContainer, toast } from 'react-toastify';
import { useTheme } from '@emotion/react';




const Login = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');

    const [emailError, setEmailError] = useState('');
    const [passwordError, setPasswordError] = useState('');

    const navigate = useNavigate();

    const { auth, setAuth } = useContext(AuthContext);

    const [searchParams, setSearchParams] = useSearchParams();

    const [isLoading, setLoading] = useState(false);

    const [isErrorAlertShowing, setErrorAlertShowing] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');

    const [showPassword, setShowPassword] = useState(false);

    const theme = useTheme();
    const isMd = useMediaQuery(theme.breakpoints.up('md'));

    useEffect(() => {
        if (auth?.user) {
            handleNavigation(auth?.user);
        }
    }, []);


    function validate() {
        setEmailError('');
        setPasswordError('')


        let isValid = true;

        const email_trimmed = email.trim();
        const password_trimmed = password.trim();


        if (email_trimmed === '') {
            setEmailError('Email is required')
            isValid = false
        } else if (email_trimmed.length > 50) {
            setEmailError('Email is too long')
            isValid = false
        }


        if (password_trimmed === '') {
            setPasswordError('Password is required')
            isValid = false
        } else if (password_trimmed.length > 50) {
            setPasswordError('Password is too long')
            isValid = false
        }



        return isValid;
    }

    function handleSubmit(event) {
        event.preventDefault();
        let isValid = validate()

        if (!isValid) {
            return
        }

        setErrorAlertShowing(false);


        attemptLogin();
    }

    // function attemptLogin() {

    //     login({ email, password }).then(res => {
    //             const token = res.data.token;
    //             const user = res.data.user;

    //             localStorage.setItem('agent-connect-api-token', token);
    //             localStorage.setItem('agent-connect-current-user', JSON.stringify(user));

    //             setAuth({
    //                 token,
    //                 user
    //             });

    //             const next = searchParams.get('next');

    //             if (next) {
    //                 navigate(next);
    //             } else {
    //                 navigate('/overview');
    //             }


    //         }).catch(error => {
    //             toast.error(error.response.data.message, {
    //                 autoClose: 2000,
    //                 hideProgressBar: true,
    //             });
    //         }
    //         )
    // }

    async function attemptLogin() {
        try {
            setLoading(true);

            const res = await login({ email, password }); // Await the login API call
            const token = res.data.token;
            const user = res.data.user;

            localStorage.setItem('agent-connect-api-token', token);
            localStorage.setItem('agent-connect-current-user', JSON.stringify(user));

            setAuth({
                token,
                user
            });

            const next = searchParams.get('next');

            if (next) {
                navigate(next);
            } else {
                handleNavigation(user);

            }
        } catch (error) {
            // Handle error with toast notification
            // toast.error(error.response?.data?.message || 'An error occurred', {
            //     autoClose: 2000,
            //     hideProgressBar: true,
            // });

            setErrorMessage(error.response?.data?.message);
            setErrorAlertShowing(true);
        } finally {
            setLoading(false);

        }
    }

    function handleNavigation(user) {


        if (user.user_type === 'Agent') {
            navigate('/overview');
        } else if (user.user_type === 'Admin') {
            navigate('/clients');
        }
    }

    const handleClickShowPassword = () => {
        setShowPassword(!showPassword);
    };

    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };

    return (
        <Box sx={{
            overflow: 'hidden',
            height: { xs: '100vh', md: '100vh' },
            width: { xs: '100vw', md: '100vw' },
            display: 'flex',
            flexDirection: { xs: 'column', md: 'row' },
            background: '#fff',
            opacity: 0,
            animation: 'fadeInPage 1.5s ease forwards',
            '@keyframes fadeInPage': {
                '0%': { opacity: 0 },
                '100%': { opacity: 1 },
            },
            backgroundImage: { xs: `url(${process.env.PUBLIC_URL + "/images/login-image.png"})`, md: 'none' },
            backgroundSize: 'cover',
            backgroundPosition: 'center',
        }}>
            {/* Left side image box - unchanged */}
            <Box sx={{
                flex: { xs: 0, md: 1 },
                display: { xs: 'none', md: 'flex' },
                justifyContent: 'center',
                alignItems: 'center',
                animation: 'fadeIn 1s ease-in-out',
                '@keyframes fadeIn': {
                    '0%': { opacity: 0 },
                    '100%': { opacity: 1 },
                },
            }}>
                <img
                    src={process.env.PUBLIC_URL + "/images/login-image.png"}
                    alt="Login Illustration"
                    style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                />
            </Box>

            <Box sx={{
                flex: 1,
                display: 'flex',
                flexDirection: 'column',
                width: '100%',
                // width: { xs: '100%', md: '100%', lg: '50%', xl: '100%' },
                backdropFilter: { xs: 'blur(15px)', md: 'none' },
                position: 'relative',
            }}>
                {/* Logo section */}
                <Box sx={{ pl: { xs: 2, md: 3 }, pt: { xs: 5, md: 3 } }}>
                    <Typography variant='h5' className="agent-title">
                        Agent
                    </Typography>
                    <Typography variant='h5' sx={{ color: '#3328BF' }} className="connect-title">
                        Connect+
                    </Typography>
                </Box>

                {/* Glassmorphism form container */}
                <Box sx={{
                    flex: { xs: .7, md: .9 },
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    px: { xs: 4, sm: 8, md: 15, lg: 15 },
                    mt: { xs: 8, md: 0 },
                }}>
                    {/* Glassmorphism effect wrapper */}
                    <Box sx={{
                        background: 'rgba(255, 255, 255, 0.40)',
                        backdropFilter: 'blur(10px)',
                        borderRadius: '16px',
                        border: {
                            xs: '1px solid rgba(255, 255, 255, 0.18)',
                            md: 'none'
                        },
                        boxShadow: {
                            xs: '0 8px 32px 0 rgba(31, 38, 135, 0.15)',
                            md: 'none'
                        },
                        padding: '2rem',

                    }}>
                        <Typography variant="h4" sx={{
                            mb: 2,
                            color: '#1a1a1a',
                            fontWeight: '500',
                        }}>
                            Login
                        </Typography>

                        {isErrorAlertShowing && (
                            <Alert
                                sx={{
                                    mb: 2,
                                    background: 'rgba(255, 0, 0, 0.1)',
                                    backdropFilter: 'blur(5px)',
                                }}
                                severity="error"
                                onClose={() => { setErrorAlertShowing(false) }}
                            >
                                {errorMessage}
                            </Alert>
                        )}

                        <form onSubmit={handleSubmit}>
                            <TextField
                                label="Email"
                                variant="filled"
                                fullWidth
                                sx={isMd ? {
                                    mb: 2,
                                    '& .MuiFilledInput-root': {
                                        transition: 'border-color 0.3s ease, box-shadow 0.3s ease',
                                        '&.Mui-focused': {
                                            boxShadow: '0 0 5px rgba(51, 40, 191, 0.4)',
                                        },
                                    },
                                } : {
                                    mb: 2,
                                    '& .MuiFilledInput-root': {
                                        background: 'rgba(255, 255, 255, 0.15)',
                                        transition: 'all 0.3s ease',
                                        '&:hover': {
                                            background: 'rgba(255, 255, 255, 0.25)',
                                        },
                                        '&.Mui-focused': {
                                            background: 'rgba(255, 255, 255, 0.35)',
                                            boxShadow: '0 0 5px rgba(51, 40, 191, 0.4)',
                                        },
                                    },
                                }}
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                placeholder="Enter your email"
                                autoComplete='email'
                                type='email'
                                error={emailError !== ''}
                                helperText={emailError}
                                autoFocus
                            />

                            <TextField
                                label="Password"
                                type={showPassword ? "text" : "password"}
                                variant="filled"
                                fullWidth
                                sx={isMd ? {
                                    mb: 2,
                                    '& .MuiFilledInput-root': {
                                        transition: 'border-color 0.3s ease, box-shadow 0.3s ease',
                                        '&.Mui-focused': {
                                            boxShadow: '0 0 5px rgba(51, 40, 191, 0.4)',
                                        },
                                    },
                                } : {
                                    mb: 2,
                                    '& .MuiFilledInput-root': {
                                        background: 'rgba(255, 255, 255, 0.15)',
                                        transition: 'all 0.3s ease',
                                        '&:hover': {
                                            background: 'rgba(255, 255, 255, 0.25)',
                                        },
                                        '&.Mui-focused': {
                                            background: 'rgba(255, 255, 255, 0.35)',
                                            boxShadow: '0 0 5px rgba(51, 40, 191, 0.4)',
                                        },
                                    },
                                }}
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                placeholder="Enter your password"
                                error={passwordError !== ''}
                                helperText={passwordError}
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            <IconButton
                                                onClick={() => setShowPassword(!showPassword)}
                                                edge="end"
                                            >
                                                {showPassword ? <VisibilityOff /> : <Visibility />}
                                            </IconButton>
                                        </InputAdornment>
                                    ),
                                }}
                            />

                            <Box sx={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'space-between',
                                mt: 2
                            }}>
                                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                    <Button
                                        disabled={isLoading}
                                        variant="contained"
                                        type='submit'
                                        sx={{
                                            height: { xs: '45px', sm: '40px' },
                                            width: { xs: '100%', sm: '90px' },
                                            background: 'rgba(51, 40, 191, 0.9)',
                                            backdropFilter: 'blur(5px)',
                                            '&:active': {
                                                transform: 'translateY(1px)',
                                            },
                                        }}
                                    >
                                        Login
                                    </Button>
                                    {isLoading && <CircularProgress size={24} sx={{ ml: 2 }} />}
                                </Box>
                                <Button
                                    to="/forgot_password"
                                    LinkComponent={Link}
                                    sx={{
                                        color: '#3328BF',
                                        '&:hover': {
                                            background: 'rgba(51, 40, 191, 0.1)',
                                        },
                                    }}
                                >
                                    Forgot Password
                                </Button>
                            </Box>
                        </form>
                    </Box>
                </Box>
            </Box>
        </Box>
    );
};

export default Login;
